import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { socket } from 'socket'
import { makeSelectFetchWorkspace } from 'containers/Settings/Workspace/selectors'
import { createStructuredSelector } from 'reselect'

const SocketHandler = ({
  children, workspace, name, onCallback, customKey
}) => {

  useEffect(() => {
    if (!workspace?.id) {
      return
    }

    const eventName = `notification-v2-${workspace.id}`

    const handler = (data) => {
      const payload = data.payload
      const matchName = customKey || 'name'
      if (payload?.[matchName] === name) {
        onCallback?.(payload)
      }
    }

    socket.on(eventName, handler)

    return () => {
      socket.off(eventName, handler)
    }
  }, [workspace?.id, name, onCallback, customKey])

  return children
}

const mapStateToProps = createStructuredSelector({ workspace: makeSelectFetchWorkspace() })
const withConnect = connect(mapStateToProps, null)
export default withConnect(SocketHandler)